import React from 'react';
import Box from '../../atoms/Box/Box';
import Text from '../../atoms/Text/Text';
import BodyTitle from '../../atoms/BodyTitle';

import IconDiscount from '../../atoms/Icon/IconDiscount';
import IconDiscovery from '../../atoms/Icon/IconDiscovery';
import IconReviews from '../../atoms/Icon/IconReviews';

const icons = {
  discount: IconDiscount,
  discovery: IconDiscovery,
  reviews: IconReviews,
};

type HomeInfoProps = {
  icon: keyof typeof icons;
  title: string;
  message: string;
};

const HomeInfo = ({ icon, title, message }: HomeInfoProps) => {
  const IconComponent = icons[icon];
  return (
    <Box textAlign="center">
      <IconComponent mb="25px" />
      <BodyTitle size="m" as="h2" mt={0}>
        {title}
      </BodyTitle>
      <Text maxWidth="350px" m="0 auto">
        {message}
      </Text>
    </Box>
  );
};

export default HomeInfo;
